import React from 'react';
import './App.css'; // Import the CSS file
import { BrowserRouter as Router, Routes, Route, Navigate  } from 'react-router-dom';
import RouteWrapper from './routes/RouteWrapper';
import TimeoutMessage from './components/TimeoutMessage';

function App() {
  // const DefaultRouter = RouteWrapper
  const DefaultRouter = TimeoutMessage
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <Routes>
            <Route path="/conferenza2024/:token" element={<DefaultRouter />} />
            <Route path="/conferenza2025/:token" element={<DefaultRouter />} />
            <Route path="/conferenza2026/:token" element={<DefaultRouter />} />
            <Route path="/" element={<Navigate replace to="/conferenza2026/error" />} /> {/* Ensure this redirection is what you want */}
          </Routes>
        </header>
      </div>
    </Router>
  );
}

export default App;
